// extracted by mini-css-extract-plugin
export var body = "layout-module--body--34qgy";
export var main = "layout-module--main--3uaNv";